<template>
  <div style="margin-left: auto;" class="hide">
    <div class="item-m bg-delete-icon-button rnd-switch shadow z-sticky rowcenter" style="position: absolute; margin-top: -0.95rem; margin-left: -0.08rem;">
      <svg-item icon="x" styles="size-s main-m" style="margin-top: -0.185rem;"/>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
.bg-delete-icon-button {
  background: rgba(255, 255, 255, 0.4);
  border: 1px solid rgba(30, 30, 30, 0.16);
}
</style>